<template>
    <div class="mt-2 mb-2" style="background-color: rgb(255, 255, 255);">
        <v-layout row class="pa-0 ma-0">
            <v-flex xs6>
                <div
                    class="font-weight-medium pa-2"
                    style="background-color: #43a047; color: #fff"
                >
                    Old
                </div>
                <pre
                    style="border: 2px solid #43a047; background-color: #fffdf0; white-space: break-spaces;"
                    class="pa-2"
                    >{{ row.old | pretty }}</pre
                >
            </v-flex>
            <v-flex xs6>
                <div
                    class="font-weight-medium pa-2"
                    style="background-color: #43a047; color: #fff"
                >
                    New
                </div>
                <pre
                    style="border: 2px solid #43a047; background-color: #fffdf0; white-space: break-spaces"
                    class="pa-2"
                    >{{ row.new | pretty }}</pre
                >
            </v-flex>
        </v-layout>
    </div>
</template>
<script>
import moment from "moment";

export default {
    props: {
        row: Object,
        columns: Array,
        reloadGrid: Function,
    },
    data() {
        return {};
    },
    filters: {
        pretty: function(value) {
            return JSON.stringify(JSON.parse(value), null, 2);
        },
    },
    async created() {},
    computed: {},
    methods: {},
};
</script>
<style></style>
